import localScaleManager from "../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../helpers/tweensConfigs";
import Button from "../modals/objects/button";

export default class BuyInMenu {
  /**
   * @param scene {GameScene}
   */
  constructor(scene) {
    this.scene = scene;
    this.button = new Button(this.scene, "buy-in-btn", true);
    this.button.on("pointerup", this.onClick, this); //D
    this.button.setOrigin(0);
    this.menu = {};
  }
  onClick() {
    // this.button.disableInteractive();
    this.button.onClick(() => {
      if (this.scene.isSceneObjectsInteractive) {
        this.scene.addMoreChipModal.show(this.scene.getVisitedTable());
        // .finally(() => {
        // this.button.enableInteractive();
        // });
      }
    });
  }
  changePosition(x) {
    const initPosition =
      this.scene.gameWidth -
      this.menu.menuMargin -
      this.button.displayWidth;
    this.button.setX(x + initPosition);
  }
  scrollTo(positionX) {
    const initPosition =
      this.scene.gameWidth -
      this.menu.menuMargin -
      this.button.displayWidth;
    this.scene.tweens.add({
      targets: this.button,
      x: initPosition + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
    });
  }
  positionControls(width, height) {
    // let btnSize = this.scene.getVisitedTable().displayWidth / 1.7;
    const tWidth =  this.scene.getVisitedTable().displayWidth;
    const tHeight =  this.scene.getVisitedTable().displayHeight;
    let btnSize =  Math.min(tWidth / 15, tHeight / 15)
    localScaleManager.scaleSprite(this.button, btnSize, btnSize, 0, 1, true);
    this.initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.menu = this.scene.header.menu;
    // this.button
    //   .setPosition(
    //     this.initX +
    //       this.scene.gameWidth -
    //       this.menu.menuMargin * 2 -
    //       this.menu.toggleButton.displayWidth -
    //       this.button.displayWidth,
    //     this.menu.menuMargin
    //   )
    //   .setVisible(false);
    this.menuMargin = this.menu.toggleButton.displayWidth / 2;

    this.button
      .setPosition(
        this.initX +
        this.scene.gameWidth -
        this.menuMargin -
        this.button.displayWidth,
        this.menu.toggleButton.y + this.menuMargin * 2 + this.menu.toggleButton.displayHeight + this.scene.realTimeResultsMenu.icon.displayHeight + this.button.displayHeight / 2
      )
      .setVisible(false);
  }
  reposition(width, height) {
    this.initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.menu = this.scene.header.menu;
    // this.button
    //   .setPosition(
    //     this.initX +
    //       this.scene.gameWidth -
    //       this.menu.menuMargin * 2 -
    //       this.menu.toggleButton.displayWidth -
    //       this.button.displayWidth,
    //     this.menu.menuMargin
    //   )
    //   .setVisible(false);
    this.button
    .setPosition(
      this.initX +
      this.scene.gameWidth -
      this.menuMargin -
      this.button.displayWidth,
      this.menu.toggleButton.y + this.menuMargin * 3 + this.menu.toggleButton.displayHeight + this.scene.realTimeResultsMenu.icon.displayHeight
    )
    .setVisible(false);
  }
}
